import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=4df9ccf6"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=4df9ccf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports